

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";

const COLUMN_MAPPING = {
    Temp_out: "Coolant_Temp_Out_Temp_Interpolated_Mean", 
    Temp_in: "Coolant_Temp_In_Temp_Interpolated_Mean",
    Temp_Inout_diff: "Coolant_InOut_Diff_Mean"
};

const Test3 = ({ filterdata }) => {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [packType, setPackType] = useState("A");
    const [packData, setPackData] = useState([]);
    const [apiType, setApiType] = useState("Temp_out");
    

    useEffect(() => {
        const columnName = COLUMN_MAPPING[apiType];
        console.log('dwkljcj=',columnName);
        fetchData(
            {
                url: `${API_URL_MAIN}battery_digital_twin/Coolant_${apiType}`,
                body: { packType, filterdata },
            },
            (data) => {
                if (data && Array.isArray(data))  {

                    let xArray=[]
                    let yArray=[]


                    console.log("data",data)
                    const uniqueData = Array.from(
                        new Map(data.map(item => [JSON.stringify(item), item])).values()
                    );
                     
                    
                    let newData=uniqueData.sort((a,b)=>new Date(a.Time_id[0]) - new Date(b.Time_id[0]))
                   
                    newData?.map((item) => {
                       xArray.push(...item.Time_id)
                       yArray.push(...item[columnName]  ) 

                    }
                    );
                    setPackData({time:xArray, value:yArray});

                }
            }
        );
    }, [packType, apiType, filterdata]);
    
    return (
        
<div className="p-6 bg-gray-100 min-h-screen flex justify-center items-center">
            <div className="bg-white rounded-xl shadow-md w-full max-w-[1200px] grid grid-cols-12 gap-4">
                {/* Left Sidebar for Controls */}
                <div className="col-span-3 p-4 border-r">
                    <div className="mb-6">
                        <div className="flex items-center mb-2">
                           
                            <div className="flex space-x-5">
                                {["A", "B", "C", "D"].map((pack) => (
                                    <label key={pack} className="inline-flex items-center">
                                        <input
                                            type="radio"
                                            value={pack}
                                            checked={packType === pack}
                                            onChange={() => setPackType(pack)}
                                            className="form-radio h-4 w-4 text-blue-600 mr-1"
                                        />
                                        <span>Pack {pack}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="mb-4">
                        <label className="block font-semibold mb-2">State of health:</label>
                        <select 
                            value={apiType} 
                            onChange={(e) => setApiType(e.target.value)} 
                            className="w-full border border-gray-300 rounded-lg px-4 py-2"
                        >
                            {Object.keys(COLUMN_MAPPING).map((key) => (
                                <option key={key} value={key}>{key}</option>
                            ))}
                        </select>
                    </div>

                   
                </div>

                {/* Main Chart Area */}
                <div className="col-span-9 p-4">
                    {isLoading && <p className="text-center text-blue-500">Loading data...</p>}
                    {error && <p className="text-center text-red-500">Error: {error}</p>}
                    {/* {packData.length > 0 && ( */}
                    {packData.time?.length && (
                       
                    
                    
                  <Plot
      data={[
        {
      
          x: packData?.time,  
         y: packData?.value,
          mode: "lines",
          name: "Mean",
          line: { color: "red", width: 2 },
        },
        {
          x: packData?.time,
          y: packData?.value?.map(itm=> itm+5),
          mode: "lines",
          name: "+Sigma",
          line: { color: "black", dash: "dot", width: 2 },
        },
        {
          x: packData?.time,
          y: packData?.value?.map(itm=> itm-5),
          mode: "lines",
          name: "-Sigma",
          line: { color: "black", dash: "dot", width: 2 },
        },
      ]}
      layout={{
        title: "Coolant Temperature Trend",
        xaxis: { title: "Time (sec)" },
        yaxis: { title: "Temperature (°C)" },
        legend: { orientation: "h", x: 0.3, y: 1.2 },
      }}
      config={{ responsive: true,  displayModeBar: false }} 
      style={{ width: "100%", height: "400px" }}
    />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Test3;